import {
  getTeamMemberListData,
  _getTMSelectItemDataById,
} from '../teamMembers/mockData'
import { getCompanyListDataByAccountId } from '../companies/mockData'
import { getAccountDocumentListDataByAccountId } from '../accountDocuments/mockData'
import { getAccountNoteListDataByAccountId } from '../accountNotes/mockData'
import { getListDataFunctionFactory } from '../../modules/getListDataFunctionFactory'
import {
  getAccountStatusById,
  AccountStatusIds,
} from '~/services/selectLists/accountStatii'
import type { IAccount, IAccountOverview } from '~/types/account/models'
import type { TEntityId } from '~/types/models'

const accountListData = undefined as unknown as IAccount[]

export const getAccountListData = getListDataFunctionFactory<IAccount[]>({
  listData: accountListData,
  storageKey: 'accounts',
  getStartingListData: getStartingAccountListData,
  // sortFunction: (a, b) => {
  //   if (b.descr < a.descr) {
  //     return 1
  //   }
  //   if (b.descr > a.descr) {
  //     return -1
  //   }
  //   return 0
  // },
})

export function _getADataById(id: TEntityId, list: IAccount[]): IAccount {
  if (!list) {
    throw new Error(`_getADataById called with undefined/null list`)
  }
  const account = list.find((a: IAccount) => a.id === id)
  if (!account) {
    throw new Error(`Can't find account '${id}'`)
  }
  return account
}

export async function getAccountDataById(id: TEntityId): Promise<IAccount> {
  const list = await getAccountListData()
  return _getADataById(id, list)
}

export async function getAccountListDataByCompanyId(
  id: TEntityId
): Promise<IAccount[]> {
  const list = await getAccountListData()
  return (
    list.filter(
      (account: IAccount) =>
        account.company?.id === id || account.contact?.company?.id === id
    ) ?? []
  )
}

export async function getAccountListDataByOwnerId(
  id: TEntityId
): Promise<IAccount[]> {
  const list = await getAccountListData()
  if (!list) {
    throw new Error(`accountList returned undefined/null`)
  }
  const accounts =
    list.filter((a: IAccount) => a.owner && a.owner.id === id) ?? []
  return accounts
}

export async function getAccountOverviewData(
  id: string
): Promise<IAccountOverview | undefined> {
  const theAccountData = await getAccountDataById(id)
  if (!theAccountData) {
    throw new Error(`Account data for ${id} not found`)
  }
  const theOverviewData = {
    account: theAccountData,
    companies: await getCompanyListDataByAccountId(id),
    accountDocuments: (await getAccountDocumentListDataByAccountId(id)) || [],
    accountNotes: (await getAccountNoteListDataByAccountId(id)) || [],
    // Properties below not currently used for account
    // opportunities: getOpportunityListDataByAccountId(id),
    // lastSelectedState: getAccountLastSelectedStateDataByAccountId(id),
    // tasks: getTaskListDataByAccountId(id),
    // calls: getCallListDataByAccountId(id),
    // emails: getEmailListDataByAccountId(id),
    // meetings: getMeetingListDataByAccountId(id),
  }
  return theOverviewData
}

// Need to have assigned to check assignedTo array, not standalone object.  JR
// This method is not currently called from anywhere.
//
// export function getAccountListDataByTeamMemberId(id: TEntityId): IAccount[] {
//   const list = getAccountListData()
//   if (!list) {
//     throw new Error(`accountList returned undefined/null`)
//   }
//   const accounts =
//     list.filter(
//       (a: IAccount) => a.owner?.id === id || a.assignedTo?.id === id
//     ) ?? []
//   return accounts
// }

export async function getStartingAccountListData(): Promise<IAccount[]> {
  const tmList = await getTeamMemberListData()
  return [
    {
      id: 'XXA0001',
      hrid: 'A0001',
      descr: 'Metropolis Bank',
      owner: _getTMSelectItemDataById('XXTM0001', tmList)!,
      numCompanies: 1,
      numServices: 230,
      numOpenOpportunities: 1,
      numOpenCases: 4,
      status: getAccountStatusById(AccountStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXA0002',
      hrid: 'A0002',
      descr: 'Far Reaching Health',
      owner: _getTMSelectItemDataById('XXTM0003', tmList)!,
      numCompanies: 1,
      numServices: 57,
      numOpenOpportunities: 2,
      numOpenCases: 0,
      status: getAccountStatusById(AccountStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXA0003',
      hrid: 'A0003',
      descr: 'Boston Coach',
      owner: _getTMSelectItemDataById('XXTM0001', tmList)!,
      numCompanies: 1,
      numServices: 110,
      numOpenOpportunities: 1,
      numOpenCases: 0,
      status: getAccountStatusById(AccountStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXA0004',
      hrid: 'A0004',
      descr: 'Boston Medical Center',
      owner: _getTMSelectItemDataById('XXTM0001', tmList)!,
      numCompanies: 1,
      numServices: 150,
      numOpenOpportunities: 0,
      numOpenCases: 0,
      status: getAccountStatusById(AccountStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXA0005',
      hrid: 'A0005',
      descr: 'Full Rack Data Center',
      owner: _getTMSelectItemDataById('XXTM0001', tmList)!,
      numCompanies: 1,
      numServices: 32,
      numOpenOpportunities: 0,
      numOpenCases: 0,
      status: getAccountStatusById(AccountStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXA0006',
      hrid: 'A0006',
      descr: 'Watch Co',
      owner: _getTMSelectItemDataById('XXTM0007', tmList)!,
      numCompanies: 1,
      numServices: 75,
      numOpenOpportunities: 0,
      numOpenCases: 0,
      status: getAccountStatusById(AccountStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXA0007',
      hrid: 'A0007',
      descr: 'Stratham Coach',
      owner: _getTMSelectItemDataById('XXTM0002', tmList)!,
      numCompanies: 1,
      numServices: 50,
      numOpenOpportunities: 0,
      numOpenCases: 0,
      status: getAccountStatusById(AccountStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXA0008',
      hrid: 'A0008',
      descr: 'Durham Medical Center',
      owner: _getTMSelectItemDataById('XXTM0002', tmList)!,
      numCompanies: 1,
      numServices: 112,
      numOpenOpportunities: 0,
      numOpenCases: 0,
      status: getAccountStatusById(AccountStatusIds.ACTIVE),
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXA0009',
      hrid: 'A0009',
      descr: 'Alpaca Farms, Inc.',
      owner: _getTMSelectItemDataById('XXTM0001', tmList)!,
      numCompanies: 1,
      numServices: 2,
      numOpenOpportunities: 0,
      numOpenCases: 0,
      status: getAccountStatusById(AccountStatusIds.ACTIVE),
      createdAt: '2023-11-15T17:32:00.000Z',
      modifiedAt: '2023-11-15T17:32:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
    {
      id: 'XXA0010',
      hrid: 'A0010',
      descr: 'Northwestern Mutual',
      owner: _getTMSelectItemDataById('XXTM0001', tmList)!,
      numCompanies: 1,
      numServices: 0,
      numOpenOpportunities: 0,
      numOpenCases: 0,
      status: getAccountStatusById(AccountStatusIds.ACTIVE),
      createdAt: '2024-01-25T21:54:00.000Z',
      modifiedAt: '2024-01-25T21:54:00.000Z',
      version: '1',
      canBeDeleted: false,
    },
  ]
}
